webpackJsonp([107818501498521],{

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies
	// eslint-disable-line import/no-extraneous-dependencies
	
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode;title = postMeta.title;
	
	      description = postMeta.metaDescription;
	      if (postMeta.featuredImage !== null) {
	        image = postMeta.featuredImage.file.url ? postMeta.featuredImage.file.url : undefined;
	      }
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', {
	        property: 'fb:app_id',
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:creator',
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	SEO.propTypes = {
	  postNode: _propTypes2.default.object,
	  postPath: _propTypes2.default.string,
	  postSEO: _propTypes2.default.bool
	};
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  blogPostDir: 'blog', // The name of directory that contains your posts.
	  siteTitle: 'Killasser Parish Church', // Site title.
	  siteTitleAlt: 'Killasser Parish Church', // Alternative site title for SEO.
	  // siteLogo: '/assets/images/logos/ironcove-large-logo.png', // Logo used for SEO and manifest.
	  siteUrl: 'https://killasser-parish.netlify.com/about', // Domain of your website without pathPrefix.
	  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-material-starter/.
	  // googleTagManagerId: 'GTM-89N8',
	  fixedFooter: false, // Whether the footer component is fixed, i.e. always visible
	  siteDescription: 'The online community for the Parish of Killasser. Here you will find interesting facts, photos and forthcoming events about your community.', // Website description used for RSS feeds/meta description tag.
	  siteRss: '/rss.xml', // Path to the RSS file.
	  // siteFBAppID: '629904053861902', // FB Application ID for using app insights
	  // siteGATrackingID: 'UA-20307710-3', // Tracking code ID for google analytics.
	  // disqusShortname: 'https-vagr9k-github-io-gatsby-material-starter', // Disqus shortname.
	  // postDefaultCategoryID: 'Tech', // Default category for posts.
	  // userName: 'Material User', // Username to display in the author segment.
	  // userTwitter: 'sandeep8851', // Optionally renders "Follow Me" in the UserInfo segment.
	  userLocation: 'Killasser, Mayo Ireland', // User location to display in the author segment.
	  // userAvatar: 'https://api.adorable.io/avatars/150/test.png', // User avatar to display in the author segment.
	  userDescription: 'The online community for the Parish of Killasser. Here you will find interesting facts, photos and forthcoming events about your community.', // User description to display in the author segment.
	  // Links to social profiles/projects you want to display in the author segment/navigation bar.
	  // userLinks: [
	  //   {
	  //     label: 'LinkedIn',
	  //     url: 'https://www.linkedin.com/company/iron-cove-solutions/',
	  //     iconClassName: 'fa fa-linkedin',
	  //   },
	  //   {
	  //     label: 'Google+',
	  //     url: 'https://plus.google.com/+Ironcovesolutions',
	  //     iconClassName: 'fa fa-google-plus',
	  //   },
	  //   {
	  //     label: 'Tumblr',
	  //     url: 'http://ironcovesolutions.tumblr.com/',
	  //     iconClassName: 'fa fa-tumblr',
	  //   },
	  //   {
	  //     label: 'Youtube',
	  //     url: 'https://www.youtube.com/user/ironcovesolutions',
	  //     iconClassName: 'fa fa-youtube',
	  //   },
	  //   {
	  //     label: 'Facebook',
	  //     url: 'https://www.facebook.com/IronCoveSolutions',
	  //     iconClassName: 'fa fa-facebook',
	  //   },
	  //   {
	  //     label: 'Twitter',
	  //     url: 'https://twitter.com/Ironcove',
	  //     iconClassName: 'fa fa-twitter',
	  //   },
	  //   {
	  //     label: 'Email',
	  //     url: 'sales@ironcovesolutions.com',
	  //     iconClassName: 'fa fa-envelope',
	  //   },
	  // ],
	  copyright: 'Copyright © 2018. Killasser Church Parish' // Copyright string for the footer of the website and RSS feed.
	};

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CustomLink = __webpack_require__(19);
	
	var _CustomLink2 = _interopRequireDefault(_CustomLink);
	
	var _SEO = __webpack_require__(170);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies
	// eslint-disable-line import/no-extraneous-dependencies
	
	
	var BlogPost = function (_Component) {
	  _inherits(BlogPost, _Component);
	
	  function BlogPost() {
	    _classCallCheck(this, BlogPost);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BlogPost.prototype.render = function render() {
	    var _props$data$contentfu = this.props.data.contentfulBlog,
	        title = _props$data$contentfu.title,
	        slug = _props$data$contentfu.slug,
	        metaDescription = _props$data$contentfu.metaDescription,
	        body = _props$data$contentfu.body,
	        featuredImage = _props$data$contentfu.featuredImage;
	    // const postNode = body.childMarkdownRemark
	    // const post = postNode.html
	
	    var postNode = this.props.data.contentfulBlog;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: title + ' | ' + this.props.data.site.siteMetadata.title,
	        meta: [{
	          name: 'description',
	          content: metaDescription
	        }]
	      }),
	      _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	      _react2.default.createElement(
	        'div',
	        { id: 'main' },
	        _react2.default.createElement(
	          'section',
	          { id: 'section-one' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { style: { color: 'antiquewhite' } },
	                title
	              )
	            ),
	            featuredImage ? _react2.default.createElement('img', { src: featuredImage.file.url, alt: title }) : undefined,
	            _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: body.childMarkdownRemark.html
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(_CustomLink2.default, { whereTo: '/blog', whereToText: 'Back to Blog List' })
	        ),
	        _react2.default.createElement('hr', null)
	      )
	    );
	  };
	
	  return BlogPost;
	}(_react.Component);
	
	BlogPost.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = BlogPost;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-7948f550869a48749d94.js